/**
 * Etiqueta e título de um crédito de Ações de Engajamento. Mesmas regras do
 * antigo `translateTitle` do PointItem, agora como dado: o cartão decide como
 * desenhar.
 */
export interface TituloDaAcao {
  etiqueta?: string;
  titulo: string;
}

const NOMES_DE_CAMPANHA: Record<string, string> = {
  agasalho_maio_2023: 'da Campanha do Agasalho 2023',
  voluntariado_maio_2023: 'do Jogando Juntos no Voluntariado',
};

const FESTA_JUNINA = 'Campanha de festa junina 2025';

function semNivel(fase?: string) {
  return fase ? fase.replace(/Nível \d+ - /, '') : '';
}

export function tituloDaAcao(item: any, cycleLabel?: string): TituloDaAcao {
  const atributos = item?.log?.attributes ?? {};
  const ideiaSimplifique = !!(atributos.tag || atributos.role);

  if (atributos.campanha === 'copa_2026') {
    return { etiqueta: 'Álbum BB 2026', titulo: atributos.blocoNome ?? 'Seleção Joga Junto' };
  }

  if (atributos.campanha === FESTA_JUNINA) {
    return { etiqueta: 'Arraiá do Reconhecimento', titulo: 'Você enviou um Correio de Elogios' };
  }

  if (atributos.campanha) {
    const campanha = NOMES_DE_CAMPANHA[atributos.campanha] ?? atributos.campanha;

    return ideiaSimplifique
      ? { titulo: campanha }
      : { etiqueta: 'Campanha', titulo: `Você participou ${campanha}` };
  }

  if (item?.log?.action === 'Entrou por convite') {
    return { etiqueta: 'Ação', titulo: `Convide seus amigos - Convite aceito por ${item.extra?.target_nome_guerra ?? ''}` };
  }

  if (atributos.desafio && atributos.titulo_desafio) {
    return { etiqueta: 'Desafio', titulo: `Você participou ${atributos.preposicao ?? 'do'} ${atributos.titulo_desafio}` };
  }

  if (atributos.type === 'challenge') {
    return { etiqueta: 'Desafio', titulo: atributos.title };
  }

  return { etiqueta: 'Desafio', titulo: `Bônus de Colaboração - ${semNivel(atributos.fase)} - ${cycleLabel}` };
}
